import React from 'react'
import { UseFormReturn } from 'react-hook-form'

import { LoadingButton } from '@mui/lab'
import {
  DialogContent,
  Box,
  Divider,
  DialogActions,
  Button,
  Stack
} from '@mui/material'

import {
  FormProvider,
  MUITextField,
  DatePickerField
} from 'src/components/fields'
import { DatePickerService } from 'src/services/DatePickerService'

interface HolidayFormDialogProps extends FormDialogProps {
  methods: UseFormReturn<HolidaysFV>
}

const HolidayFormDialog: React.FC<HolidayFormDialogProps> = ({
  isView,
  methods,
  onClose,
  onSubmit
}) => {
  const {
    formState: { isSubmitting }
  } = methods

  return (
    <FormProvider methods={methods} onSubmit={methods.handleSubmit(onSubmit)}>
      <DialogContent>
        <Stack spacing={3}>
          <Box
            sx={{
              display: 'grid',
              rowGap: 3,
              columnGap: 2,
              gridTemplateColumns: {
                xs: 'repeat(1, 1fr)',
                sm: 'repeat(2, 1fr)'
              }
            }}
          >
            <MUITextField name="name" label="Name *" disabled={isView} />

            <DatePickerField
              name="date"
              label="Date *"
              width="100%"
              disabled={isView}
              shouldDisableDate={DatePickerService.findWeekendDays}
            />
          </Box>
        </Stack>
      </DialogContent>

      <Divider />

      <DialogActions>
        <Button
          size="medium"
          color="inherit"
          variant="outlined"
          onClick={onClose}
        >
          Cancel
        </Button>
        <LoadingButton
          size="medium"
          type="submit"
          variant="contained"
          loading={isSubmitting}
        >
          Submit
        </LoadingButton>
      </DialogActions>
    </FormProvider>
  )
}

export default HolidayFormDialog
